function formatDate(date) {
	var dateFormat;
	var timeFormat;
	var d = new Date(date),
		month = '' + (d.getMonth() + 1),
		day = '' + d.getDate(),
		year = d.getFullYear(),
		hour = d.getHours(),
		minute = d.getMinutes(),
		seconds = d.getSeconds();
	if (month.length < 2) month = '0' + month;
	if (day.length < 2) day = '0' + day;

	dateFormat = [year, month, day].join('-');
	timeFormat = [hour, minute, seconds].join(':');
	return dateFormat + ' ' + timeFormat;
}

export const nwlKeys = {
	dtId: (orgId, locationId) =>
		`nwl:selectedDtId:${orgId}:${locationId}`,
	simId: (orgId, locationId) =>
		`nwl:selectedSimId:${orgId}:${locationId}`,
};
